<template>
    <v-app>
        <component :is="this.$route.meta.layout || 'div'">
                <router-view/>


        </component>

        <NotificationSnackbar/>
    </v-app>
</template>

<script>

    import {mapGetters} from "vuex";
    import NotificationSnackbar from "./components/NotificationSnackbar";

    export default {
        name: 'App',
        components: {NotificationSnackbar},
        metaInfo: {
            title: 'Home',
            // all titles will be injected into this template
            titleTemplate: '%s | Helios'
        },
        computed: {
            ...mapGetters('auth', [
                'isAuthenticated',
                'getUser',
            ]),
        },
    }
</script>
<style>
    html, body {
        background-color: #fafafa;
        height: 100%;
        min-height: 100%;
    }
    .theme--light.v-application {
        background-color: #fafafa !important;
    }
</style>